import { useGameReportData } from '@/hooks/gameReport/useGameReportData';
import GameCard from './GameCard';
import styles from './styles.module.scss';
import BetDetails from './BetDetails';
import { useGameReportSearchParams } from '@/hooks/gameReport/useGameReportSearchParams';
import { GameReportType } from '@/hooks/gameReport/useGameReportSearchParams/gameReportType.enum';
import GameDetails from './GameDetails';
import GameScoreboard from './GameScoreboard';
import Divider from './BetDetails/Divider';
import { ErrorCard, Image } from '@starsoft/common/components';

export default function GameReportModalContent() {
  const { type } = useGameReportSearchParams();
  const { error, refetch, bets } = useGameReportData();

  if (error) {
    return (
      <div className={styles.container}>
        <ErrorCard error={error} refetch={refetch} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.container__background}>
        <Image
          className={styles.container__background__image}
          src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/coins-background.webp`}
          alt="coins background"
        />
      </div>

      <div className={styles.container__content}>
        {(type === GameReportType.BetGame || (!!bets && bets?.length > 0)) && (
          <BetDetails />
        )}
        <GameCard />
        <GameDetails />
        {type === GameReportType.RoundGame && (
          <>
            <Divider />
            <GameScoreboard />
          </>
        )}
      </div>
    </div>
  );
}
